module.exports = __webpack_public_path__ + "693ef0d28.png";